import { defineMessages } from '../../i18n/messages';

export const TermsMessages = defineMessages({
  PAGE_TITLE: {
    id: 'terms.page_title',
    text: 'Terms of Service',
    description: 'Page title for the terms of service page',
  },
  SUBTITLE: {
    id: 'terms.subtitle',
    text: 'The agreement between you and Localingos.',
    description: 'Subtitle shown below the page title on the terms of service page',
  },
  SERVICE_TITLE: {
    id: 'terms.service_title',
    text: '1. Service',
    description: 'Numbered section header on the terms page describing the service',
  },
  SERVICE_DESC: {
    id: 'terms.service_desc',
    text: 'Localingos is a developer-first automated localization platform. We provide AI-powered translation of your content into multiple locales via our CLI, API, and web dashboard.',
    description: 'Body text under Service section. CLI is a command-line interface tool',
  },
  ACCOUNTS_TITLE: {
    id: 'terms.accounts_title',
    text: '2. Accounts',
    description: 'Numbered section header on the terms page for account requirements',
  },
  ACCOUNTS_DESC: {
    id: 'terms.accounts_desc',
    text: 'You must provide accurate information when creating an account. You are responsible for maintaining the security of your API keys and credentials. One account per person or organization.',
    description: 'Body text under Accounts section. API keys are secret tokens for programmatic access',
  },
  FREE_TRIAL_TITLE: {
    id: 'terms.free_trial_title',
    text: '3. Free Trial',
    description: 'Numbered section header on the terms page for trial terms',
  },
  FREE_TRIAL_DESC: {
    id: 'terms.free_trial_desc',
    text: 'New accounts receive a free trial with 5,000 translated words included. No credit card is required. Once the trial word quota is exhausted, your account becomes read-only until you subscribe to a paid plan. Remaining trial words carry over when you upgrade.',
    description: 'Body text under Free Trial section explaining trial limits and behavior',
  },
  SUBSCRIPTIONS_TITLE: {
    id: 'terms.subscriptions_title',
    text: '4. Subscriptions',
    description: 'Numbered section header on the terms page for billing terms',
  },
  SUBSCRIPTIONS_DESC: {
    id: 'terms.subscriptions_desc',
    text: 'Paid plans (Starter, Growth, and Scale) are billed annually via Stripe. You can upgrade at any time and pay the prorated difference. Downgrades are available when your current usage is within the target plan\'s quota. Cancellations take effect at the end of the current billing period. A single billing account may be shared across multiple projects.',
    description: 'Body text under Subscriptions section. Stripe is a third-party payment processor',
  },
  USAGE_LIMITS_TITLE: {
    id: 'terms.usage_limits_title',
    text: '5. Usage Limits',
    description: 'Numbered section header on the terms page for quota details',
  },
  USAGE_LIMITS_DESC: {
    id: 'terms.usage_limits_desc',
    text: 'Each plan includes a yearly word quota. "Translated words" means source word count multiplied by the number of target locales. Usage is tracked per project and per billing period. When your quota is reached, new translation jobs are blocked until the next billing period or a plan upgrade.',
    description: 'Body text under Usage Limits section. Locales are language/region combinations like en-US',
  },
  YOUR_CONTENT_TITLE: {
    id: 'terms.your_content_title',
    text: '6. Your Content',
    description: 'Numbered section header on the terms page for content ownership',
  },
  YOUR_CONTENT_DESC: {
    id: 'terms.your_content_desc',
    text: 'You retain full ownership of all content you submit. We process your content solely to provide translations using third-party AI services (Amazon Bedrock). We do not use your content to train AI models. You can export or delete your content at any time via the CLI, API, or dashboard.',
    description: 'Body text under Your Content section explaining data ownership and AI usage',
  },
  ACCEPTABLE_USE_TITLE: {
    id: 'terms.acceptable_use_title',
    text: '7. Acceptable Use',
    description: 'Numbered section header on the terms page for usage restrictions',
  },
  ACCEPTABLE_USE_DESC: {
    id: 'terms.acceptable_use_desc',
    text: 'You agree not to use Localingos for unlawful content, to reverse-engineer the service, to exceed rate limits through automated abuse, or to resell the service without permission.',
    description: 'Body text under Acceptable Use section listing prohibited activities',
  },
  AVAILABILITY_TITLE: {
    id: 'terms.availability_title',
    text: '8. Availability',
    description: 'Numbered section header on the terms page for uptime disclaimers',
  },
  AVAILABILITY_DESC: {
    id: 'terms.availability_desc',
    text: 'We aim for high availability but do not guarantee uninterrupted service. We are not liable for losses caused by downtime, translation errors, or service interruptions.',
    description: 'Body text under Availability section with liability disclaimer',
  },
  TERMINATION_TITLE: {
    id: 'terms.termination_title',
    text: '9. Termination',
    description: 'Numbered section header on the terms page for account termination terms',
  },
  TERMINATION_DESC: {
    id: 'terms.termination_desc',
    text: 'Either party may terminate at any time. We may suspend accounts that violate these terms. Upon termination, your data will be retained for 30 days before permanent deletion.',
    description: 'Body text under Termination section explaining data retention after account closure',
  },
  CHANGES_TITLE: {
    id: 'terms.changes_title',
    text: '10. Changes',
    description: 'Numbered section header on the terms page for terms update policy',
  },
  CHANGES_DESC: {
    id: 'terms.changes_desc',
    text: 'We may update these terms with 30 days notice via email. Continued use after changes constitutes acceptance.',
    description: 'Body text under Changes section explaining how terms updates are communicated',
  },
  CONTACT_TITLE: {
    id: 'terms.contact_title',
    text: 'Contact',
    description: 'Section header on the terms page for contact information',
  },
  CONTACT_DESC: {
    id: 'terms.contact_desc',
    text: 'Questions? Email <a href="mailto:legal@localingos.com">legal@localingos.com</a>.',
    description: 'Body text under Contact section. Contains HTML mailto link',
  },
  LAST_UPDATED: {
    id: 'terms.last_updated',
    text: 'Last updated: April 2026',
    description: 'Timestamp shown at the bottom of the terms of service page',
  },
});
